import * as React from 'react';
import Svg, { Path } from 'react-native-svg';

import { ds } from '@/components/lib/design.system';

export const LeagueMenuIcon = () => (
    <Svg width={24} height={24} viewBox="0 0 24 24" fill="none">
        <Path
            d="M4.79999 15.6001L14.4 15.6001"
            stroke={ds.colorValue.icon.primary}
            strokeWidth={1.75}
            strokeLinecap={'round'}
        />
        <Path
            d="M4.79999 8.3999L19.2 8.3999"
            stroke={ds.colorValue.icon.primary}
            strokeWidth={1.75}
            strokeLinecap={'round'}
        />
    </Svg>
);
